// --- Utility to refresh the session token for autocomplete requests ---
export const refreshToken = (request, AutocompleteSessionToken) => {
  try {
    if (request.sessionToken && request.sessionToken instanceof AutocompleteSessionToken) {
      request.sessionToken = new AutocompleteSessionToken();
    } else {
      // missing or invalid token, create a new one
      request.sessionToken = new AutocompleteSessionToken();
    }
  } catch (e) {
    console.warn('AutocompleteSessionToken not available. Creating a new one.', e);
    request.sessionToken = new AutocompleteSessionToken();
  }
};
